module.exports = __webpack_public_path__ + "static/media/n-create.b6dbc917.svg";